/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SpaProductCrunchtimeMicrocategoryDTO = {
    BEAUTY_SERVICE: 'BEAUTY_SERVICE',
    BODY_TREATMENTS: 'BODY_TREATMENTS',
    EDUTAINMENT_VERKAUF: 'EDUTAINMENT_VERKAUF',
    EDUTAINMENT_WORKSHOP: 'EDUTAINMENT_WORKSHOP',
    HAIR_SERVICE: 'HAIR_SERVICE',
    HEALTH_SERVICE: 'HEALTH_SERVICE',
    WELLNESS_SERVICE: 'WELLNESS_SERVICE'
} as const;
export type SpaProductCrunchtimeMicrocategoryDTO = typeof SpaProductCrunchtimeMicrocategoryDTO[keyof typeof SpaProductCrunchtimeMicrocategoryDTO];

